import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import EventIcon from '@mui/icons-material/Event';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import TranslateIcon from '@mui/icons-material/Translate';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import swal from 'sweetalert';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import Client from './Client';
import Config from './ClientConfig';

import DropDown from './DropDown';
import KImage from './KImage';

import noImage from './../images/noImage.png';
import active_on from './../images/icons/active_on.png';
import active_off from './../images/icons/active_off.png';

// Utility: list promotions with a backend limit (keeps lists light)
export async function fetchPromotionsList(client, limit = 50, extraParams = {}) {
  const base = (client && client.prefix ? client.prefix : '') + Config.API_URL_PROMOTIONS;
  const qs = new URLSearchParams({ limit: String(limit) });
  for (const [k, v] of Object.entries(extraParams || {})) {
    if (v !== undefined && v !== null && v !== '') qs.append(k, String(v));
  }
  const url = base + (base.includes('?') ? '&' : '?') + qs.toString();
  const res = await fetch(url, { method: 'GET' });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  return await res.json();
}

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const StableKImage = React.memo(KImage, (prev, next) =>
  prev.edit === next.edit &&
  prev.image.data === next.image.data // only care if actual image string changes
);

// canonical list endpoints (as you provided)
const API_URL_PRODUCTS = Config.API_URL_PRODUCT + 'list_products/';
const API_URL_COMBOS   = Config.API_URL_COMBO   + 'list_combos/';
const API_URL_FAMILIES = Config.API_URL_CLIENT_FAMILY;
const API_URL_PROFESSIONALS = Config.API_URL_CLIENT_PRO;

let LANGS_CACHE = null;
let LANGS_BY_ID = null;
let LANGS_LOADING = null;
const LIST_CACHE = new Map(); // product/combo list cache, keyed by endpoint + real filters
const COUNTY_CACHE = new Map(); // key: country_id -> { options, dict }
const LIST_CACHE_TTL_MS = 60 * 1000;
function clearPromotionListCache() {
  LIST_CACHE.clear();
}

export default class Promotion extends React.Component {

  constructor(props) {
    super(props);
    const today = this.toBusinessDate(new Date().toISOString()).slice(0, 10);
    this.state = {
      client: new Client('none'),
      promotion: {
        iref: '',
        name: '',
        description: '',
        image: null,
        dateFrom: props.isNew ? `${today}T00:00:00` : '',
        dateTo: props.isNew ? `${today}T23:59:59` : '',
        frequency: 0,
        type: 0,
        value: 0,
        vCode: null,
        isActive: true,
        maxClaims: null,
        pin_position: 0,

        // links (IDs)
        client: null,
        family: null,
        professional: null,
        product: null,
        combo: null,
        county: null,
        counties: [],

        // triggers
        ageFrom: 0,
        ageTo: 0,
        gender: 9,
        firstNameLike: null,
        onBirthday: false,
        proximity: 0,
        orderAnciencyMonths: 0,

        promot_promotion: [],
      },
      expanded: !!props.isNew, 
      edit: !!props.isNew,
      allowEdit: props.allowEdit !== false,
      saveButtonVisible: false,
      tabValue: 'details',
      somethingHasChanged: false,
      isSaving: false,
      imgVersion: 0,

      // translations
      translations: [],
      languages: [],
      langById: {},
      languagesReady: false,
      isSavingTr: false,
      trEdit: {},
      _primedSelections: false,
      _unmounted: false,

      // enums — aligned with backend
      typeOptions: { 0:'FULL', 1:'DISCOUNT_VALUE', 2:'DISCOUNT_PERCENTAGE' },
      frequencyOptions: { 0:'ONCE', 1:'ONCE_A_DAY', 2:'NO_LIMIT', 3:'ONCE_A_WEEK', 4:'ONCE_A_MONTH' },
      genderOptions: { 1:'Female', 2:'Male', 9: 'Undefined' },
      proximityOptions: { 0:'NONE', 1:'NEAR', 2:'FAR' },
      pinOptions: { 0: 'None', 1: '1st', 2: '2nd', 3: '3rd' },

      // async search helpers
      productOpts: [],
      productOptsAll: [],
      productSearching: false,
      productObj: null,
      comboOpts: [],
      comboOptsAll: [],
      comboSearching: false,
      comboObj: null,
      familyOpts: [],
      familyOptsAll: [],
      familySearching: false,
      familyObj: null,
      professionalOpts: [],
      professionalSearching: false,
      professionalObj: null,
      counties: [],          // [{ iref, name }]
      countyOpts: {},        // { [iref]: name } for DropDown
      countyObjs: [],        // selected county target objects
      targetMode: 'all',
    };
    this.originalPromotion = {
      ...this.state.promotion,
      counties: [],
    };
    this.pendingPromotionProp = null;

    this.handleExpandClick = this.handleExpandClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.pushData = this.pushData.bind(this);

    this.changeType = this.changeType.bind(this);
    this.changeFrequency = this.changeFrequency.bind(this);
    this.changeGender = this.changeGender.bind(this);
    this.changeProximity = this.changeProximity.bind(this);

    this.addBlankTranslation = this.addBlankTranslation.bind(this);
    this.toggleTrEdit = this.toggleTrEdit.bind(this);

    this.getImage = this.getImage.bind(this);
    this._prefetchedProd = false;
    this._prefetchedCombo = false;
    this._lastImgRaw = undefined;
    this._kimgImageObj = { data: '' };
  }

  // ---------- date helpers (UI = yyyy-mm-dd, backend = dd-mm-YYYY) ----------
  ymdToDmy(s){
    if (!s || s.length < 10) return '';
    const [y,m,d] = s.split('-');
    return `${d}-${m}-${y}`;
  }
  dmyToYmd(s){
    if (!s || s.length < 10) return '';
    const [d,m,y] = s.split('-');
    return `${y}-${m}-${d}`;
  }
  // ================= Date helpers (support datetime-local) =================
  toBusinessDate(value) {
    const s = String(value || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}[ T].*(?:Z|[+-]\d{2}:?\d{2})$/i.test(s)) return s;
    const instant = new Date(s.replace(' ', 'T'));
    if (Number.isNaN(instant.getTime())) return '';
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Bucharest',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    }).formatToParts(instant).map(({ type, value: part }) => [type, part]));
    return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
  }

  toPayloadDate(raw, { endOfDay = false, preserveOffset = false } = {}) {
    if (!raw) return null;
    const s = this.toBusinessDate(raw);
    // An untouched API timestamp retains its exact instant, including at DST overlaps.
    const original = String(raw).trim();
    if (preserveOffset && s && /^\d{4}-\d{2}-\d{2}[ T].*(?:Z|[+-]\d{2}:?\d{2})$/i.test(original)) {
      return original.replace(' ', 'T');
    }
    // Date-only To values include the whole day; preserve explicit times.
    const time = (match) => match[4] === undefined
      ? (endOfDay ? '23:59:59' : '00:00:00')
      : `${match[4]}:${match[5]}:${match[6] || '00'}`;

    // YYYY-MM-DD or YYYY-MM-DD[ T]HH:mm[:ss][.sss][Z]
    let m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(s);
    if (m) return `${m[1]}-${m[2]}-${m[3]} ${time(m)}`;

    // DD-MM-YYYY or DD-MM-YYYY[ T]HH:mm[:ss]
    m = /^(\d{2})-(\d{2})-(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(s);
    if (m) return `${m[3]}-${m[2]}-${m[1]} ${time(m)}`;

    return null;
  }
  toYMD(value) {
    if (!value) return '';
    const s = this.toBusinessDate(value);

    let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s); // handles YYYY-MM-DD, YYYY-MM-DDTHH:mm:ss
    if (m) return `${m[1]}-${m[2]}-${m[3]}`;

    m = /^(\d{2})-(\d{2})-(\d{4})/.exec(s); // handles DD-MM-YYYY
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;

    return '';
  }
  toDMY(value) {
    if (!value) return '';
    const s = this.toBusinessDate(value);

    let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s); // YYYY-MM-DD -> DD-MM-YYYY
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;

    m = /^(\d{2})-(\d{2})-(\d{4})/.exec(s); // already DMY
    if (m) return `${m[1]}-${m[2]}-${m[3]}`;

    return '';
  }

  toDateTimeInput = (value, endOfDay = false) => (
    this.toPayloadDate(value, { endOfDay })?.slice(0, 16).replace(' ', 'T') || ''
  );

  scheduleLabel = (value, endOfDay = false) => (
    value ? `${this.toDMY(value)} ${this.toPayloadDate(value, { endOfDay })?.slice(11, 16) || ''}` : '—'
  );

  changeSchedule = (field, value) => {
    this.setState((state) => {
      const previous = state.promotion[field];
      let next = value;
      if (next) {
        const oldValue = this.toDateTimeInput(previous, field === 'dateTo');
        const sameTime = oldValue && oldValue.slice(11) === next.slice(11);
        const seconds = sameTime
          ? this.toPayloadDate(previous, { endOfDay: field === 'dateTo' }).slice(17, 19)
          : field === 'dateTo' && next.endsWith('T23:59') ? '59' : '00';
        next = next === oldValue ? previous : `${next}:${seconds}`;
      }
      return {
        promotion: { ...state.promotion, [field]: next },
        somethingHasChanged: true,
      };
    });
  };

  primeSelectionsOnce = async () => {
    if (this._primedSelections) return;
    this._primedSelections = true;
    try { await this.primeSelections(); } catch {}
  };

  safeImageSrc = (raw) => {
    let s = raw && typeof raw === 'object' ? (raw.data || raw.url || raw.src || '') : (raw || '');
    if (typeof s !== 'string') s = '';
    s = s.replace(/\\r?\\n/g, '').trim();
    if (!s) return noImage;
    if (s.startsWith('data:image') && s.includes(';base64,')) return s;
    if (/^https?:\/\//i.test(s)) {
      try {
        const url = new URL(s);
        if (url.pathname.startsWith('/media/')) {
          return `${Config.BASE_URL}${url.pathname}${url.search}`;
        }
      } catch {}
      return s;
    }
    if (s.startsWith('/') || s.startsWith('./') || s.startsWith('../')) return s;
    return noImage;
  };

  componentDidMount() {
    const incoming = this.props.promotion ? this.normalizePromotion(this.props.promotion) : null;
    if (incoming) {
      const countyIds = this.countyIds(incoming);
      this.originalPromotion = {
        ...incoming,
        counties: [...countyIds],
      };
      this.setState({
        promotion: incoming,
        targetMode: countyIds.length ? 'selected' : 'all',
      }, () => {
        // load counties *after* promotion is in state so we know county id
        this.updateGeoData('country061', countyIds);
        this.primeSelectionsOnce();
        if (incoming.family) {
          this.fetchFamilyById(incoming.family);
        } else {
          this.setState({ familyObj: null });
        }
        if (incoming.professional) {
          this.fetchProfessionalById(incoming.professional);
        } else {
          this.setState({ professionalObj: null });
        }
      });
    } else {
      // no incoming promotion -> still ensure counties list is present
      this.originalPromotion = {
        ...this.state.promotion,
        counties: [],
      };
      this.updateGeoData('country061', []);
    }

    this.loadLanguages();
  }
  componentDidUpdate(prevProps, prevState) {
    // when a new promotion arrives via props
    if (
      this.props.promotion &&
      this.props.promotion !== prevProps.promotion
    ) {
      const p = this.normalizePromotion(this.props.promotion);
      const countyIds = this.countyIds(p);
      if (this.state.edit) {
        this.pendingPromotionProp = {
          ...p,
          counties: [...countyIds],
        };
      } else {
        this.pendingPromotionProp = null;
        this.originalPromotion = {
          ...p,
          counties: [...countyIds],
        };

        this._primedSelections = false;

        this.setState({
          promotion: p,
          targetMode: countyIds.length ? 'selected' : 'all',
          somethingHasChanged: false,
        }, () => {
          this.updateGeoData('country061', countyIds);
          this.primeSelectionsOnce();

          if (p.family) {
            this.fetchFamilyById(p.family);
          } else {
            this.setState({ familyObj: null });
          }

          if (p.professional) {
            this.fetchProfessionalById(p.professional);
          } else {
            this.setState({ professionalObj: null });
          }
        });
      }
    }
    if (
      String(prevState.promotion?.product || '') !==
      String(this.state.promotion?.product || '')
    ) {
      this.fetchProductById(this.state.promotion?.product);
    }
    if (
      String(prevState.promotion?.combo || '') !==
      String(this.state.promotion?.combo || '')
    ) {
      this.fetchComboById(this.state.promotion?.combo);
    }
    if (
      String(prevState.promotion?.family || '') !==
      String(this.state.promotion?.family || '')
    ) {
      this.fetchFamilyById(this.state.promotion?.family);
    }
  }
  componentWillUnmount() {
    this._unmounted = true;
  }

  // to replace "country061" with value from Config/Platform (PLATFORM_DEFAULT_COUNTRY)
  countyId = (county) => {
    const id = county && typeof county === 'object'
      ? county.iref
      : county;
    return id === null || typeof id === 'undefined' || id === ''
      ? null
      : String(id);
  };

  countyIds = (promotion = {}) => {
    const raw = Array.isArray(promotion.counties)
      ? promotion.counties
      : [promotion.county];
    return raw
      .map((county) => this.countyId(county))
      .filter((county, index, values) => (
        county && values.indexOf(county) === index
      ));
  };

  selectedCountyIds = () => (
    this.state.targetMode === 'selected'
      ? this.countyIds(this.state.promotion)
      : []
  );

  countyNames = (promotion = {}) => {
    const names = this.countyIds(promotion)
      .map((countyId) => this.state.countyOpts[countyId])
      .filter(Boolean);
    return names.length ? names.join(', ') : 'All';
  };

  targetSummary = () => {
    const count = this.selectedCountyIds().length;
    if (this.state.targetMode === 'all') {
      return 'Visible in every county. The promotion is stored once.';
    }
    if (!count) return 'Select at least one county.';
    return `Visible in ${count} selected ${count === 1 ? 'county' : 'counties'}. The promotion is stored once.`;
  };

  promotionHasClaims = (promotion = {}) => (
    promotion.hasClaims === true
    || promotion.hasClaims === 1
    || promotion.hasClaims === '1'
    || promotion.hasClaims === 'true'
  );

  relatedId = (value) => {
    if (value && typeof value === 'object') {
      return value.iref ?? value.id ?? value.value ?? null;
    }
    return value ?? null;
  };

  promotionFingerprint = (promotion = {}) => {
    const normalizedNumber = (value) => (
      value === null || typeof value === 'undefined' || value === ''
        ? null
        : Number(value)
    );
    const normalizedBoolean = (value) => (
      value === true || value === 1 || value === '1' || value === 'true'
    );
    const normalizedImage = (() => {
      const raw = promotion.image && typeof promotion.image === 'object'
        ? (
          promotion.image.data
          || promotion.image.url
          || promotion.image.src
          || ''
        )
        : (promotion.image || '');
      return String(raw)
        .trim()
        .replace(/^https?:\/\/[^/]+/i, '')
        .split('?')[0];
    })();

    return JSON.stringify({
      isActive: normalizedBoolean(promotion.isActive),
      maxClaims: normalizedNumber(promotion.maxClaims),
      name: String(promotion.name || ''),
      description: String(promotion.description || ''),
      dateFrom: this.toPayloadDate(
        promotion.dateFrom,
        { endOfDay: false },
      ) || '',
      dateTo: this.toPayloadDate(
        promotion.dateTo,
        { endOfDay: true },
      ) || '',
      frequency: normalizedNumber(promotion.frequency),
      image: normalizedImage,
      type: normalizedNumber(promotion.type),
      value: normalizedNumber(promotion.value),
      client: String(this.relatedId(promotion.client) || ''),
      family: String(this.relatedId(promotion.family) || ''),
      professional: String(this.relatedId(promotion.professional) || ''),
      product: String(this.relatedId(promotion.product) || ''),
      combo: String(this.relatedId(promotion.combo) || ''),
      ageFrom: normalizedNumber(promotion.ageFrom),
      ageTo: normalizedNumber(promotion.ageTo),
      gender: normalizedNumber(promotion.gender),
      firstNameLike: String(promotion.firstNameLike || ''),
      onBirthday: normalizedBoolean(promotion.onBirthday),
      counties: this.countyIds(promotion),
      proximity: normalizedNumber(promotion.proximity),
      vCode: String(promotion.vCode || '').trim().toUpperCase(),
      orderAnciencyMonths: normalizedNumber(
        promotion.orderAnciencyMonths,
      ),
      pin_position: normalizedNumber(promotion.pin_position),
    });
  };

  fetchLatestPromotion = () => {
    const promotionId = this.state.promotion?.iref;
    if (!promotionId) return null;

    try {
      const data = this.state.client.getData(
        Config.API_URL_PROMOTIONS,
        { iref: promotionId, limit: 1 },
      );
      const promotions = Array.isArray(data?.promotions)
        ? data.promotions
        : [];
      const latest = promotions.find(
        (promotion) => String(promotion.iref || '') === String(promotionId),
      );
      if (
        !latest
        || data.status === 'ERROR'
      ) {
        return null;
      }
      return this.normalizePromotion(latest);
    } catch {
      return null;
    }
  };

  changedClaimFields = (current = {}, original = {}) => {
    const normalizedNumber = (value) => (
      value === null || typeof value === 'undefined' || value === ''
        ? ''
        : Number(value)
    );
    const normalizers = {
      vCode: (value) => String(value || '').trim().toUpperCase(),
      type: normalizedNumber,
      value: normalizedNumber,
      product: (value) => String(this.relatedId(value) || ''),
      combo: (value) => String(this.relatedId(value) || ''),
      frequency: normalizedNumber,
      dateFrom: (value) => this.toPayloadDate(value, { endOfDay: false }) || '',
      dateTo: (value) => this.toPayloadDate(value, { endOfDay: true }) || '',
    };
    const labels = {
      vCode: 'voucher code',
      type: 'type',
      value: 'value',
      product: 'product',
      combo: 'combo',
      frequency: 'frequency',
      dateFrom: 'start date',
      dateTo: 'end date',
    };

    return Object.entries(normalizers)
      .filter(([field, normalize]) => (
        normalize(current[field]) !== normalize(original[field])
      ))
      .map(([field]) => labels[field]);
  };

  setTargetMode = (_, mode) => {
    if (!mode) return;
    this.setState((state) => ({
      targetMode: mode,
      countyObjs: mode === 'all' ? [] : state.countyObjs,
      promotion: mode === 'all'
        ? { ...state.promotion, county: null, counties: [] }
        : state.promotion,
      somethingHasChanged: true,
    }));
  };

  updateGeoData = (country_id = 'country061', countyIds = []) => {
    const selectedIds = Array.isArray(countyIds)
      ? countyIds.map(String)
      : (countyIds ? [String(countyIds)] : []);
    // 1) serve from cache if available
    if (COUNTY_CACHE.has(country_id)) {
      const { options, dict } = COUNTY_CACHE.get(country_id);
      const countyObjs = options.filter((option) => (
        selectedIds.includes(option.iref)
      ));
      this.setState({
        counties: options,
        countyOpts: dict,
        countyObjs,
      });
      return;
    }
    // 2) fetch once, then cache
    const queryData = { country: country_id, orderBy_Name: true };
    const data = this.state.client.getData(Config.API_URL_COUNTY, queryData);

    let countiesArr = [];
    if (data && Array.isArray(data.counties)) {
      countiesArr = data.counties;
    }

    const options = countiesArr.map(f => ({
      iref: String(f.iref),
      name: String(f.name || '')
    }));

    const dict = {};
    options.forEach(f => { dict[f.iref] = f.name; });

    // cache for subsequent calls
    COUNTY_CACHE.set(country_id, { options, dict });

    const countyObjs = options.filter((option) => (
      selectedIds.includes(option.iref)
    ));
    this.setState({
      counties: options,
      countyOpts: dict,
      countyObjs,
    });
  };

  normalizePromotion(p0) {
    const p = Object.assign({}, p0 || {});
    const scal = (v) => (v && typeof v === 'object' ? (v.value ?? v.id ?? v.key ?? v.code ?? undefined) : v);
    p.type = scal(p.type);
    p.frequency = scal(p.frequency);
    p.gender = scal(p.gender);
    p.proximity = scal(p.proximity);
    p.maxClaims = p.maxClaims ?? null;
    const counties = Array.isArray(p.counties)
      ? p.counties.map((county) => this.countyId(county)).filter(Boolean)
      : [this.countyId(p.county)].filter(Boolean);
    p.county = counties[0] || null;
    p.counties = counties;
    return p;
  }

  // Accepts: array OR {results:[]} OR {products:[]} OR {productCombos:[]}
  async fetchList(endpoint, q) {
    try {
      const qp = (q || '').trim();

      const queryData = {};

      if (qp && qp.length >= 2) {
        queryData.search = qp;
      }

      if (endpoint === API_URL_PRODUCTS) {
        queryData.status = 2;
        queryData.isForSale = 1;
        queryData.isSoldAlone = 1;
        queryData.isSellable = 1;
        queryData.available_for_promotion = 1;
        queryData.orderBy_name = true;
      }

      if (endpoint === API_URL_COMBOS) {
        queryData.status = 2;
        queryData.isForSale = 1;
        queryData.isSellable = 1;
        queryData.available_for_promotion = 1;
        queryData.orderBy_name = true;
      }

      // Cache by the real request filters, not only by endpoint.
      // This prevents stale lists when availability rules change.
      const sortedQueryData = Object.keys(queryData)
        .sort()
        .reduce((acc, key) => {
          acc[key] = queryData[key];
          return acc;
        }, {});

      const cacheKey = endpoint + '|' + JSON.stringify(sortedQueryData);
      const cached = LIST_CACHE.get(cacheKey);
      if (cached && Date.now() - cached.createdAt < LIST_CACHE_TTL_MS) {
        return cached.data;
      }

      const data = this.state.client.getData(endpoint, queryData);

      if (!data) {
        console.warn('[fetchList] getData returned null for', endpoint);
        return [];
      }

      const list = Array.isArray(data)
        ? data
        : (Array.isArray(data?.results) ? data.results
        : (Array.isArray(data?.products) ? data.products
        : (Array.isArray(data?.productCombos) ? data.productCombos
        : (Array.isArray(data?.combos) ? data.combos : []))));

      const mapped = list.map(x => ({
        iref: String(x.iref ?? x.id ?? ''),
        name: String(x.name ?? x.productName ?? x.comboName ?? '').trim()
      })).filter(x => x.iref);

      mapped.sort((a,b)=>a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));

      LIST_CACHE.set(cacheKey, {
        createdAt: Date.now(),
        data: mapped,
      });
      return mapped;

    } catch (e) {
      console.error('[fetchList] failed for', endpoint, e);
      return [];
    }
  }

  async fetchProductById(id){ 
    if (!id) {
      this.setState({ productObj: null });
      return;
    }
    const pid = String(id);
    const all = await this.fetchList(API_URL_PRODUCTS, '');

    if (!this.state.productOpts || this.state.productOpts.length === 0) {
      this.setState({ productOpts: all, productOptsAll: all });
    }
    const obj = (all || []).find(o => String(o.iref) === pid) || null;
    this.setState({ productObj: obj });
  }
  async fetchComboById(id){ 
    if (!id) {
      this.setState({ comboObj: null });
      return;
    }
    const cid = String(id);
    const all = await this.fetchList(API_URL_COMBOS, '');
    if (!this.state.comboOpts || this.state.comboOpts.length === 0) {
      this.setState({ comboOpts: all, comboOptsAll: all });
    }
    const obj = (all || []).find(o => String(o.iref) === cid) || null;
    this.setState({ comboObj: obj });
  }

  async fetchFamilies(q) {
    try {
      const qp = (q || '').trim();

      const queryData = {
        orderBy_Name: true,
        limit: 10,
      };

      if (qp && qp.length >= 2) {
        queryData.nameLike = qp;
      } else {
        return [];
      }

      const data = this.state.client.getData(API_URL_FAMILIES, queryData);

      const list = Array.isArray(data)
        ? data
        : (
            Array.isArray(data?.clientFamilies)
              ? data.clientFamilies
              : (
                  Array.isArray(data?.results)
                    ? data.results
                    : []
                )
          );

      const mapped = list.map(x => ({
        iref: String(x.iref ?? x.id ?? ''),
        name: String(x.name ?? '').trim(),
        owner_email: String(x.owner_email ?? x.ownerEmail ?? '').trim(),
      })).filter(x => x.iref);

      const unique = Array.from(
        new Map(mapped.map(item => [String(item.iref), item])).values()
      );

      unique.sort((a, b) =>
        (a.name || '').localeCompare((b.name || ''), undefined, { sensitivity: 'base' })
      );

      return unique;
    } catch (e) {
      console.error('[fetchFamilies] failed', e);
      return [];
    }
  }

  async fetchFamilyById(id) {
    if (!id) {
      this.setState({ familyObj: null });
      return;
    }

    try {
      const data = this.state.client.getData(API_URL_FAMILIES, {
        iref: id,
        limit: 1,
      });

      const list = Array.isArray(data)
        ? data
        : (
            Array.isArray(data?.clientFamilies)
              ? data.clientFamilies
              : (
                  Array.isArray(data?.results)
                    ? data.results
                    : []
                )
          );

      const obj = list && list.length
        ? {
            iref: String(list[0].iref ?? list[0].id ?? ''),
            name: String(list[0].name ?? '').trim(),
            owner_email: String(list[0].owner_email ?? list[0].ownerEmail ?? '').trim(),
          }
        : null;

      this.setState({ familyObj: obj });
    } catch (e) {
      console.error('[fetchFamilyById] failed', e);
      this.setState({ familyObj: null });
    }
  }

  onFamilyInput = async (_e, value, reason) => {
    if (reason && reason !== 'input') return;

    const q = (value || '').trim();

    if (!q || q.length < 2) {
      this.setState({
        familyOpts: [],
        familySearching: false,
      });
      return;
    }

    this.setState({ familySearching: true });

    try {
      const opts = await this.fetchFamilies(q);
      this.setState({
        familyOpts: opts,
        familySearching: false,
      });
    } catch {
      this.setState({
        familyOpts: [],
        familySearching: false,
      });
    }
  };

  labelForFamily = (opt) => {
    if (!opt) return '';
    const name = opt.name || '';
    const email = opt.owner_email || '';
    return email ? `${name} — ${email}` : name;
  };

  async fetchProfessionals(q) {
    try {
      const qp = (q || '').trim();
      const queryData = {
        orderBy_Name: true,
        limit: 10,
      };
      if (qp && qp.length >= 2) {
        queryData.nameLike = qp;
      } else {
        return [];
      }
      const data = this.state.client.getData(API_URL_PROFESSIONALS, queryData);
      const list = Array.isArray(data)
        ? data
        : (
            Array.isArray(data?.clientProfessional)
              ? data.clientProfessional
              : (
                  Array.isArray(data?.professionals)
                    ? data.professionals
                    : (
                        Array.isArray(data?.results)
                          ? data.results
                          : []
                      )
                )
          );
      const mapped = list.map(x => {
          const members = Array.isArray(x.clientProfessional_pro)
            ? x.clientProfessional_pro
            : [];
          const owner =
            members.find(m => Number(m.level) === 0) ||
            members.find(m => m.canUseCompanyCredit) ||
            members[0];
          const ownerEmail = String(
            x.owner_email ||
            x.ownerEmail ||
            owner?.client?.user?.person?.email ||
            owner?.client?.user?.email ||
            ''
          ).trim();
          return {
            iref: String(x.iref ?? x.id ?? ''),
            name: String(x.name ?? '').trim(),
            company: String(x.company ?? '').trim(),
            owner_email: ownerEmail,
          };
        }).filter(x => x.iref);
      const unique = Array.from(
        new Map(mapped.map(item => [String(item.iref), item])).values()
      );
      unique.sort((a, b) =>
        (a.name || '').localeCompare((b.name || ''), undefined, { sensitivity: 'base' })
      );
      return unique;
    } catch (e) {
      console.error('[fetchProfessionals] failed', e);
      return [];
    }
  }

  async fetchProfessionalById(id) {
    if (!id) {
      this.setState({ professionalObj: null });
      return;
    }
    try {
      const data = this.state.client.getData(API_URL_PROFESSIONALS, {
        iref: id,
        limit: 1,
      });
      const list = Array.isArray(data)
        ? data
        : (
            Array.isArray(data?.clientProfessional)
              ? data.clientProfessional
              : (
                  Array.isArray(data?.professionals)
                    ? data.professionals
                    : (
                        Array.isArray(data?.results)
                          ? data.results
                          : []
                      )
                )
          );
      let obj = null;
      if (list && list.length) {
        const x = list[0];
        const members = Array.isArray(x.clientProfessional_pro)
          ? x.clientProfessional_pro
          : [];
        const owner =
          members.find(m => Number(m.level) === 0) ||
          members.find(m => m.canUseCompanyCredit) ||
          members[0];
        const ownerEmail = String(
          x.owner_email ||
          x.ownerEmail ||
          owner?.client?.user?.person?.email ||
          owner?.client?.user?.email ||
          ''
        ).trim();
        obj = {
          iref: String(x.iref ?? x.id ?? ''),
          name: String(x.name ?? '').trim(),
          company: String(x.company ?? '').trim(),
          owner_email: ownerEmail,
        };
      }
      this.setState({ professionalObj: obj });
    } catch (e) {
      console.error('[fetchProfessionalById] failed', e);
      this.setState({ professionalObj: null });
    }
  }

  onProfessionalInput = async (_e, value, reason) => {
    if (reason && reason !== 'input') return;
    const q = (value || '').trim();
    if (!q || q.length < 2) {
      this.setState({
        professionalOpts: [],
        professionalSearching: false,
      });
      return;
    }

    this.setState({ professionalSearching: true });
    try {
      const opts = await this.fetchProfessionals(q);
      this.setState({
        professionalOpts: opts,
        professionalSearching: false,
      });
    } catch {
      this.setState({
        professionalOpts: [],
        professionalSearching: false,
      });
    }
  };

  labelForProfessional = (opt) => {
    if (!opt) return '';
    const name = opt.name || '';
    const company = opt.company || '';
    const email = opt.owner_email || '';
    const main = company ? `${name} / ${company}` : name;
    return email ? `${main} — ${email}` : main;
  };
  
  primeSelections = async () => {
    try {
      const [prods, combos] = await Promise.all([
        this.fetchList(API_URL_PRODUCTS, '', undefined),
        this.fetchList(API_URL_COMBOS, '', undefined),
      ]);
      this.setState({
        productOptsAll: prods || [],
        productOpts: prods || [],
        comboOptsAll: combos || [],
        comboOpts: combos || [],
      });

      const pId = this.state.promotion?.product ? String(this.state.promotion.product) : null;
      const cId = this.state.promotion?.combo ? String(this.state.promotion.combo) : null;

      this.setState({
        productObj: pId ? ((prods || []).find(o => String(o.iref) === pId) || null) : null,
        comboObj: cId ? ((combos || []).find(o => String(o.iref) === cId) || null) : null,
      });
    } catch {}
  };
  
  onProductInput = (_e, value, reason) => {
    if (reason && reason !== 'input') return;
    const q = (value || '').trim().toLowerCase();
    const all = this.state.productOptsAll || [];
    if (!q) { this.setState({ productOpts: all, productSearching: false }); return; }
    // simple contains filter
    const filtered = all.filter(o => (o.name || '').toLowerCase().includes(q));
    this.setState({ productOpts: filtered, productSearching: false });
  };

  onComboInput = (_e, value, reason) => {
    if (reason && reason !== 'input') return;
    const q = (value || '').trim().toLowerCase();
    const all = this.state.comboOptsAll || [];
    if (!q) { this.setState({ comboOpts: all, comboSearching: false }); return; }
    const filtered = all.filter(o => (o.name || '').toLowerCase().includes(q));
    this.setState({ comboOpts: filtered, comboSearching: false });
  };

  // make absolute URLs relative (so client.getData won't double-prefix)
  toRelative = (u) => { if (!u) return ''; return String(u).replace(/^https?:\/\/[^/]+/i, ''); };
  // join base + path with exactly one slash
  joinUrl = (base, path) => {
    const b = (base || '').endsWith('/') ? base : (base + '/');
    const p = (path || '').startsWith('/') ? path.slice(1) : path;
    return b + p;
  };

  hasValidDates = () => {
    const { dateFrom, dateTo } = this.state.promotion || {};
    if (!dateFrom || !dateTo) return false;
    const from = this.toPayloadDate(dateFrom, { endOfDay: false });
    const to   = this.toPayloadDate(dateTo,   { endOfDay: true  });
    if (!from || !to) return false;
    return from <= to;
  };

  getDateErrors = () => {
    const { dateFrom, dateTo } = this.state.promotion || {};
    const missingFrom = !dateFrom;
    const missingTo   = !dateTo;
    if (missingFrom || missingTo) return { from: missingFrom, to: missingTo, range: false };

    const from = this.toPayloadDate(dateFrom, { endOfDay: false });
    const to   = this.toPayloadDate(dateTo,   { endOfDay: true  });
    const badRange = !from || !to || from > to;
    return { from: false, to: false, range: badRange };
  };

  // ---------- languages & translations ----------
  loadLanguages = async () => {
    if (LANGS_CACHE && LANGS_BY_ID) {
      if (!this.state.languages.length) {
        this.setState({ languages: LANGS_CACHE, langById: LANGS_BY_ID, languagesReady: true });
      } else if (!this.state.languagesReady) {
        this.setState({ languagesReady: true });
      }
      return;
    }
    if (LANGS_LOADING) {
      await LANGS_LOADING;
      this.setState({ languages: LANGS_CACHE || [], langById: LANGS_BY_ID || {}, languagesReady: true });
      return;
    }
    LANGS_LOADING = (async () => {
      const urlBase = this.toRelative(Config.API_URL_LANGUAGE || '/api/1.0/languages/');
      const data = this.state.client.getData(urlBase, {});
      const raw = Array.isArray(data?.Languages) ? data.Languages : [];
      const list = raw
        .map(x => ({ iref: String(x.iref), languageName: String(x.languageName || '').trim() }))
        .filter(x => x.iref && x.languageName);
      const map = {}; list.forEach(l => { map[l.iref] = l; });
      LANGS_CACHE = list; LANGS_BY_ID = map;
    })();

    try { await LANGS_LOADING; } finally { LANGS_LOADING = null; }
    this.setState({ languages: LANGS_CACHE, langById: LANGS_BY_ID, languagesReady: true });
  };

  loadTranslations = async () => {
    const id = this.state.promotion?.iref;
    if (!id) return;
    const base = this.toRelative(Config.API_URL_PROMOTIONS || '/api/1.0/promotion/');
    const url  = this.joinUrl(base, `${id}/translations/`);
    const data = this.state.client.getData(url, {});
    if (!data) { swal('Error','Could not load translations','error'); return; }

    const rows = Array.isArray(data?.translations) ? data.translations : [];
    const normalized = rows.map(r => {
      const langId = (r.language && typeof r.language === 'object')
        ? String(r.language.iref)
        : (r.language != null ? String(r.language) : null);
      return { ...r, language: langId };
    });
    this.setState({ translations: normalized });
  };

  onTrFieldChange = (iref, field, value) => {
    this.setState(s => ({
      translations: (s.translations || []).map(r =>
        String(r.iref) === String(iref) ? { ...r, [field]: value } : r
      )
    }));
  };

  toggleTrEdit(iref, force) {
    this.setState(s => ({
      trEdit: { ...s.trEdit, [iref]: typeof force === 'boolean' ? force : !s.trEdit[iref] }
    }));
  }

  hasOpenDraft = () => (this.state.translations || []).some(t => Number(t.iref) < 0);

  saveTranslation = async (row) => {
    const promotionId = this.state.promotion?.iref;
    if (!promotionId) { swal('Error','Save the promotion first, then add translations.','error'); return; }
    this.setState({ isSavingTr: true });

    // include iref only if it’s a real saved id
    const isRealId = row.iref && Number(row.iref) > 0;
    const payload = {
      ...(isRealId ? { iref: row.iref } : {}),
      language_iref: row.language || null,
      name: (row.name ?? '').trim(),
      description: (row.description ?? '').trim()
    };

    try {
      const base = this.toRelative(Config.API_URL_PROMOTIONS || '/api/1.0/promotion/');
      const url  = this.joinUrl(base, `${promotionId}/translations_save/`);
      const data = this.state.client.pushData(url, payload); // POST via your helper

      if (data && data.status === 'OK') {
        const saved  = data.row;
        const langId = saved?.language && typeof saved.language === 'object'
          ? String(saved.language.iref) : String(saved.language || '');
        const merged = { ...saved, language: langId || null };
        this.setState(s => {
          const list = [...s.translations];
          const idx = list.findIndex(x => x.iref === row.iref || x.iref === merged.iref);
          if (idx >= 0) list[idx] = merged; else list.unshift(merged);
          return { translations: list, isSavingTr: false, trEdit: { ...s.trEdit, [merged.iref]: false } };
        });
        swal('Saved','Translation saved.','success',{ buttons:false, timer:900 });
      } else {
        const msg = (data && (data.message || JSON.stringify(data.errors))) || 'Unknown error';
        swal('Save failed', msg, 'error'); this.setState({ isSavingTr: false });
      }
    } catch (e) {
      swal('Save failed', e.message || String(e), 'error');
      this.setState({ isSavingTr: false });
    }
  };

  addBlankTranslation = () => {
    if (this.hasOpenDraft()) {
      swal('Heads up', 'Please finish or cancel the current draft translation first.', 'info');
      return;
    }
    const tmpId = -Date.now();
    const newRow = {
      iref: tmpId,
      promotion: this.state.promotion?.iref,
      language: null,
      name: '',
      description: '',
    };
    this.setState(s => ({
      translations: [newRow, ...s.translations],
      trEdit: { ...s.trEdit, [tmpId]: true }
    }));
  };

  canEditTrRow = (t) =>
    !!this.state.allowEdit && (this.state.trEdit?.[t.iref] || t.iref < 0);

  // ---------- field changes ----------
  changeType(v){      this.setState(s=>({ promotion:{...s.promotion, type: parseInt(v,10)},      somethingHasChanged:true })); }
  changeFrequency(v){ this.setState(s=>({ promotion:{...s.promotion, frequency: parseInt(v,10)}, somethingHasChanged:true })); }
  changeGender(v){    this.setState(s=>({ promotion:{...s.promotion, gender: parseInt(v,10)},    somethingHasChanged:true })); }
  changeProximity(v){ this.setState(s=>({ promotion:{...s.promotion, proximity: parseInt(v,10)}, somethingHasChanged:true })); }

  handleExpandClick(){ this.setState((s) => ({ expanded: !s.expanded })); }

  handleEditClick = () => {
    if (!this.state.allowEdit) return;
    this.pendingPromotionProp = null;
    this.setState(prev => {
      const img = prev.promotion.image || '';
      const clean = (typeof img === 'string') ? img.replace(/\\r?\\n/g, '').trim() : '';
      return {
        edit: true,
        saveButtonVisible: true,
        expanded: true,
        promotion: { ...prev.promotion, image: clean }
      };
    });
  };

  handleCancelClick = async () => {
    if (this.props.isNew) {
      if (typeof this.props.onCancel === 'function') this.props.onCancel();
      return;
    }
    if (this.state.somethingHasChanged) {
      const confirmed = await swal({
        title: 'Discard changes?',
        text: 'Your unsaved promotion changes will be lost.',
        icon: 'warning',
        buttons: ['Keep editing', 'Discard'],
        dangerMode: true,
      });
      if (!confirmed) return;
    }
    const source = this.pendingPromotionProp || this.originalPromotion;
    const restored = {
      ...source,
      counties: [...this.countyIds(source)],
    };
    this.pendingPromotionProp = null;
    this.originalPromotion = {
      ...restored,
      counties: [...restored.counties],
    };
    const counties = this.countyIds(restored);
    this.setState({
      promotion: restored,
      edit: false,
      saveButtonVisible: false,
      somethingHasChanged: false,
      targetMode: counties.length ? 'selected' : 'all',
    }, () => {
      this.updateGeoData('country061', counties);
      if (restored.professional) {
        this.fetchProfessionalById(restored.professional);
      } else {
        this.setState({ professionalObj: null });
      }
    });
  };

  handleSaveClick = () => {
    if (document?.activeElement?.blur) {
      document.activeElement.blur();
    }
    setTimeout(() => this.pushData(), 0);
  };

  handleTabChange = async (_, tab) => {
    this.setState({ tabValue: tab }, async () => {
      if (tab === 'translations') {
        await this.loadLanguages();
        if (this.state.promotion?.iref) await this.loadTranslations();
      }
    });
  };

  changeValue(e){
    const id = e.target.id;
    const value = (e.target.type === 'checkbox') ? e.target.checked : e.target.value;
    this.setState(s => ({ promotion:{...s.promotion, [id]: value}, somethingHasChanged:true }));
  }

  parseClaimLimit = (value) => {
    const raw = String(value ?? '').trim();
    if (!raw) return null;
    if (!/^[1-9]\d*$/.test(raw)) return undefined;
    const limit = Number(raw);
    return Number.isSafeInteger(limit) ? limit : undefined;
  };

  changePinPosition = (v) => {
    this.setState((s) => ({
      promotion: { ...s.promotion, pin_position: parseInt(v, 10) },
      somethingHasChanged: true,
    }));
  };

  // KImage save callback
  getImage = (newImage) => {
    const dataStr = (newImage && typeof newImage === 'object') ? (newImage.data || '') : (newImage || '');
    this.setState(s => ({
      promotion: { ...s.promotion, image: dataStr },
      somethingHasChanged: true
    }));
  };
  async pushData() {
    const src = this.state.promotion;
    /* const isOrderWide = (!src.product && !src.combo);
    if (isOrderWide && !src.vCode) {
      swal('Missing voucher code','When no Product or Combo is selected, the promotion applies to the whole order and requires a Voucher Code.','warning');
      return;
    } */
   if (Number(src.type) === 0 && !src.product && !src.combo) {
    swal(
      'Invalid promotion',
      'For FULL promotions you must select a Product or a Combo.',
      'warning'
    );
    return;
  }
   if (src.product && src.combo) {
      swal('Invalid scope', 'Select either a Product or a Combo, not both.', 'warning');
      return;
    }
    if (!(this.state.edit && this.state.somethingHasChanged)) {
      swal('Error', 'Nothing to save', 'error');
      return;
    }
    if (!this.hasValidDates()) {
      swal('Missing or invalid period','Please set both From and To (From must be before or equal to To).','warning');
      return;
    }
    const maxClaims = this.parseClaimLimit(src.maxClaims);
    if (maxClaims === undefined) {
      swal('Invalid claim limit', 'Enter a positive whole number, or leave it blank for unlimited claims.', 'warning');
      return;
    }
    let serverBaseline = this.originalPromotion;
    if (src.iref) {
      const latestPromotion = this.fetchLatestPromotion();
      if (!latestPromotion) {
        swal(
          'Could not verify promotion',
          'The latest promotion data could not be loaded. Reload the page before saving so claims and concurrent changes are not missed.',
          'error',
        );
        return;
      }

      const serverChanged = (
        this.promotionFingerprint(latestPromotion)
        !== this.promotionFingerprint(this.originalPromotion)
      );
      if (serverChanged) {
        this.pendingPromotionProp = {
          ...latestPromotion,
          counties: [...this.countyIds(latestPromotion)],
        };
        const confirmed = await swal({
          title: 'Promotion changed elsewhere',
          text: 'The promotion was updated after you started editing. Continuing will overwrite those newer promotion fields with the values currently shown here.',
          icon: 'warning',
          buttons: ['Keep editing', 'Overwrite'],
          dangerMode: true,
        });
        if (!confirmed) return;
      }
      serverBaseline = latestPromotion;
    }

    const counties = (
      this.state.targetMode === 'selected'
        ? this.countyIds(src)
        : []
    );
    if (this.state.targetMode === 'selected' && counties.length === 0) {
      swal(
        'Select counties',
        'Choose at least one county or use All counties.',
        'warning',
      );
      return;
    }

    const originalCounties = this.countyIds(serverBaseline);
    const removedCounties = originalCounties.filter(
      (countyId) => !counties.includes(countyId)
    );
    if (src.iref && removedCounties.length) {
      const removalText = this.state.targetMode === 'all'
        ? 'The selected county associations will be removed and this promotion will become visible in every county.'
        : `${removedCounties.length} county ${removedCounties.length === 1 ? 'association' : 'associations'} will be removed.`;
      const confirmed = await swal({
        title: 'Change county targeting?',
        text: `${removalText} This affects only future eligibility; existing claims and linked orders will never be changed.`,
        icon: 'warning',
        buttons: ['Cancel', 'Continue'],
        dangerMode: true,
      });
      if (!confirmed) return;
    }

    const changedClaimFields = this.changedClaimFields(
      src,
      serverBaseline,
    );
    if (
      src.iref
      && this.promotionHasClaims(serverBaseline)
      && changedClaimFields.length
    ) {
      const confirmed = await swal({
        title: 'Change a claimed promotion?',
        text: `This promotion already has claims. Updating ${changedClaimFields.join(', ')} may change what existing unused claims receive or whether they can be redeemed. Used claims and linked orders remain unchanged.`,
        icon: 'warning',
        buttons: ['Keep editing', 'Update promotion'],
        dangerMode: true,
      });
      if (!confirmed) return;
    }

    this.setState({ isSaving: true });
    try {
      const src = this.state.promotion;
      const payload = { ...src };
      const originalIref = src.iref || null;
      delete payload.county;
      delete payload.hasClaims;
      delete payload.status;
      const rawImage = src.image && typeof src.image === 'object'
        ? (src.image.data || src.image.url || src.image.src || '')
        : (src.image || '');
      const normalizedImage = typeof rawImage === 'string'
        ? rawImage.trim()
        : '';
      if (
        normalizedImage === 'REMOVE'
        || normalizedImage.startsWith('data:image')
      ) {
        payload.image = normalizedImage;
      } else {
        delete payload.image;
      }
      payload.counties = counties;
      // normalize optionals
      payload.vCode = payload.vCode ? String(payload.vCode).toUpperCase() : null;
      payload.firstNameLike = payload.firstNameLike ? String(payload.firstNameLike) : null;
      payload.maxClaims = maxClaims;
      // dates to "YYYY-MM-DD HH:MM:SS"
      payload.dateFrom = this.toPayloadDate(src.dateFrom, { endOfDay: false, preserveOffset: true });
      payload.dateTo   = this.toPayloadDate(src.dateTo,   { endOfDay: true, preserveOffset: true });

      const r = this.state.client.pushJson(
        Config.API_URL_PROMOTIONS,
        payload,
      );
      if (r && r.status === 'OK') {
        const next = { ...this.state.promotion, ...r };
        delete next.status;
        this.pendingPromotionProp = null;
        this.originalPromotion = {
          ...next,
          counties: [...this.countyIds(next)],
        };
        this.setState({
          promotion: next,
          somethingHasChanged: false,
          isSaving: false,
          edit: false,
          saveButtonVisible: false,
        });
        swal('Saved', 'Promotion saved successfully.', 'success', { buttons: false, timer: 1200 });
        clearPromotionListCache();
        if (typeof this.props.promotionUpdated === 'function') {
          this.props.promotionUpdated(next, originalIref);
        }
        return;
      }
      const msg = (r && (r.message || (r.errors && JSON.stringify(r.errors)))) || 'Unknown error';
      swal('Save failed', msg, 'error');
      this.setState({ isSaving: false });
    } catch (e) {
      const msg = (e && e.message) ? e.message : String(e);
      swal('Save failed', msg, 'error');
      this.setState({ isSaving: false });
    }
  }

  // small helper to keep a consistent label for selected options
  labelForOption = (opt) => (opt?.name ? opt.name : '');

  _onKImageSaveBack = (img) => {
    const str = (img && typeof img === 'object') ? (img.data || '') : (img || '');
    this.setState(s => ({
      promotion: { ...s.promotion, image: str },
      somethingHasChanged: true,
      imgVersion: (s.imgVersion || 0) + 1,
    }));
  };

  render() {
    const src = this.state.promotion;
    const bothSelected = !!((src?.product) && (src?.combo));
    const p = this.state.promotion || {};
    const selectedCountyCount = this.selectedCountyIds().length;
    const countyTargetValid = (
      this.state.targetMode === 'all'
      || selectedCountyCount > 0
    );
    const imgRaw = this.state.promotion?.image || '';
    if (imgRaw !== this._lastImgRaw) {
      this._kimgImageObj = { data: this.safeImageSrc(imgRaw) };
      this._lastImgRaw = imgRaw;
    }
    const errs = this.getDateErrors();

    const coerceByName = (obj, dict) => {
      if (obj == null) return obj;
      if (typeof obj !== 'object') return obj;
      if ('value' in obj) return obj.value;
      if ('id' in obj) return obj.id;
      if ('key' in obj) return obj.key;
      if ('code' in obj) return obj.code;
      if (obj.name && dict) {
        const k = Object.keys(dict).find(kk => dict[kk] === obj.name);
        return k !== undefined ? (/^\\d+$/.test(k) ? parseInt(k,10) : k) : undefined;
      }
      return undefined;
    };
    p.type      = coerceByName(p.type, this.state.typeOptions);
    p.frequency = coerceByName(p.frequency, this.state.frequencyOptions);
    p.gender    = coerceByName(p.gender, this.state.genderOptions);
    p.proximity = coerceByName(p.proximity, this.state.proximityOptions);
    p.type      = coerceByName(p.type, this.state.typeOptions);
    if (p.type == null || !(p.type in this.state.typeOptions)) p.type = 0;
    p.frequency = coerceByName(p.frequency, this.state.frequencyOptions);
    if (p.frequency == null || !(p.frequency in this.state.frequencyOptions)) p.frequency = 0;
    p.proximity = coerceByName(p.proximity, this.state.proximityOptions);
    if (p.proximity == null || !(p.proximity in this.state.proximityOptions)) p.proximity = 0;

    const title = p.name || 'New Promotion';
    const priceWarningLabel = p.product_price_warning
      ? 'Product not available for active locations'
      : p.combo_price_warning
        ? 'Combo not available for active locations'
        : '';
    const subheaderParts = [];
    if (p.createdOn)  subheaderParts.push(`Created: ${p.createdOn}`);
    if (p.modifiedOn) subheaderParts.push(`Modified: ${p.modifiedOn}`);
    const subheader = subheaderParts.join(' • ');

    let promoImage = p.image;
    if (promoImage && typeof promoImage === 'object') {
      promoImage = promoImage.data || promoImage.url || promoImage.src || '';
    }
    if (typeof promoImage !== 'string') promoImage = '';
    promoImage = promoImage.trim();
    if (!promoImage) {
      promoImage = noImage;
    } else {
      const isDataUrl = promoImage.startsWith('data:');
      const isHttp    = /^https?:\/\//i.test(promoImage);
      const isPath    = promoImage.startsWith('/') || promoImage.startsWith('./') || promoImage.startsWith('../');
      if (!isDataUrl && (isHttp || isPath)) {
        try {
          const dot = promoImage.lastIndexOf('.');
          const slash = promoImage.lastIndexOf('/');
          if (dot > -1 && dot > slash) {
            const base = promoImage.slice(0, dot);
            const ext  = promoImage.slice(dot + 1);
            promoImage = `${base}_s.${ext}`;
          }
        } catch {}
      }
    }

    const activeAvatar = p.isActive ? active_on : active_off;
    const activeAlt = p.isActive ? 'Active' : 'Inactive';

    const typeLabel = this.state.typeOptions[p.type] || '—';
    const freqLabel = this.state.frequencyOptions[p.frequency] || '—';
    const genderLabel = this.state.genderOptions[p.gender] || '—';
    const proxLabel = this.state.proximityOptions[p.proximity] || '—';

    // ----- DETAILS (Read) -----
    const detailsReadOnly = (
      <Box sx={{ p: 1, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 1.5 }}>
        <Box>
          <Typography variant="subtitle2">Description</Typography>
          <Typography variant="body2" color="text.secondary">{p.description || '—'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">Period</Typography>
          <Typography variant="body2" color="text.secondary">
            {p.dateFrom ? ('From: ' + this.scheduleLabel(p.dateFrom)) : 'From: —'}<br />
            {p.dateTo ? ('To: ' + this.scheduleLabel(p.dateTo, true)) : 'To: —'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">Quick facts</Typography>
          <Typography variant="body2" color="text.secondary">
            Type: {typeLabel} • Frequency: {freqLabel} • Value: {p.value ?? '—'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Claim limit: {p.maxClaims == null ? 'Unlimited' : p.maxClaims}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">Links</Typography>
          <Typography variant="body2" color="text.secondary">
            {/* Client: {p.client ?? '—'} • Family: {p.family ?? '—'} • Professional: {p.professional ?? '—'}<br/> */}
            Product: {(this.state.productObj?.name || (this.state.productOpts.find(o=>o.iref===String(p.product))?.name) || '—')} • Combo: {(this.state.comboObj?.name || (this.state.comboOpts.find(o=>o.iref===String(p.combo))?.name) || '—')}
          </Typography>
        </Box>
      </Box>
    );

    // ----- DETAILS (Edit — compact) -----
    const length = (p.name || '').length;
    const detailsEdit = (() => {
      const p = this.state?.promotion || {};
      // const errs = this.state?.errs || {};

      return (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: '220px minmax(0, 1fr)' },
            gap: 1,
            alignItems: 'start',
          }}
        >
          {/* LEFT: Image */}
          <Box sx={{ width: { xs: '100%', md: 220 } }}>
            <StableKImage
              edit={this.state.edit}
              image={this._kimgImageObj}
              imageText="Promotion image"
              saveBack={this._onKImageSaveBack}
              version={this.state.imgVersion}
              key={this.state.imgVersion}
            />
          </Box>

          {/* RIGHT: Fields (strict horizontal alignment via 12-col grid) */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(12, minmax(0,1fr))',
              gap: 1.25,
              alignItems: 'start',
              minWidth: 0,
              '& .MuiFormControl-root': { m: 0, width: '100%', minWidth: 0, maxWidth: '100%' },
              '& .MuiInputBase-root': { minWidth: 0 },
              '& .MuiSelect-select': { overflow: 'hidden', textOverflow: 'ellipsis' },
            }}
          >
            {/* Status, name, and promotion rules */}
            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 4', xl: 'span 2' }, display: 'flex', alignItems: 'center' }}>
              <FormControlLabel
                sx={{ m: 0 }}
                control={
                  <Switch
                    id="isActive"
                    size="small"
                    checked={!!p.isActive}
                    onChange={(e) =>
                      this.changeValue({
                        target: { id: 'isActive', type: 'checkbox', checked: e.target.checked },
                      })
                    }
                  />
                }
                label="Active"
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 8', xl: 'span 4' }, minWidth: 0 }}>
              <TextField
                id="name"
                label="Name"
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
                value={p.name || ''}
                onChange={this.changeValue}
                inputProps={{ maxLength: 40 }}
                helperText={`${length} / 40`}
                FormHelperTextProps={{
                  sx: {
                    textAlign: 'right',
                    color: length > 32 ? 'warning.main' : 'text.secondary',
                  },
                }}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', xl: 'span 2' }, minWidth: 0 }}>
              <DropDown
                name="Type"
                value={String(p.type ?? 0)}
                size="small"
                doptions={this.state.typeOptions}
                hasIcons={false}
                onChangeFunction={(v) => this.changeType(v)}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', xl: 'span 2' }, minWidth: 0 }}>
              <DropDown
                name="Frequency"
                value={String(p.frequency ?? 0)}
                size="small"
                doptions={this.state.frequencyOptions}
                hasIcons={false}
                onChangeFunction={(v) => this.changeFrequency(v)}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', xl: 'span 2' }, minWidth: 0 }}>
              <TextField
                id="maxClaims"
                type="text"
                size="small"
                margin="dense"
                variant="outlined"
                label="Claim limit"
                placeholder="Unlimited"
                fullWidth
                value={p.maxClaims ?? ''}
                onChange={this.changeValue}
                inputProps={{ inputMode: 'numeric' }}
                error={this.parseClaimLimit(p.maxClaims) === undefined}
                helperText={this.parseClaimLimit(p.maxClaims) === undefined
                  ? 'Whole number above 0'
                  : 'Blank = unlimited'}
                FormHelperTextProps={{ sx: { whiteSpace: 'nowrap' } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip
                        arrow
                        title="Blank means unlimited; 0 is invalid. The limit counts all claims ever issued. Once reached, new claims stop. Clients with an unredeemed claim can still see and use it; the promotion stays active."
                      >
                        <IconButton size="small" aria-label="About claim limit">
                          <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            {/* Placement, period, and value */}
            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', xl: 'span 2' }, minWidth: 0 }}>
              <Box sx={{ minWidth: 0, width: '100%' }}>
                <DropDown
                  name="Top position"
                  value={String(p.pin_position ?? 0)}
                  size="small"
                  doptions={this.state.pinOptions}
                  hasIcons={false}
                  minWidth={0}
                  maxWidth={999}
                  onDark={false}
                  onChangeFunction={this.changePinPosition}
                  style={{ width: '100%' }}
                />
              </Box>
            </Box>
            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', xl: 'span 3' }, minWidth: 0 }}>
              <TextField
                id="dateFrom_ui"
                label="From"
                type="datetime-local"
                  inputProps={{ step: 60 }}
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
                value={this.toDateTimeInput(p.dateFrom, false)}
                onChange={(e) => this.changeSchedule('dateFrom', e.target.value)}

                InputLabelProps={{ shrink: true }}
                error={errs.from || errs.range}
                helperText={errs.from ? 'Required' : errs.range ? 'From must be ≤ To' : 'Europe/Bucharest'}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', xl: 'span 3' }, minWidth: 0 }}>
              <TextField
                id="dateTo_ui"
                label="To"
                type="datetime-local"
                  inputProps={{ step: 60 }}
                size="small"
                margin="dense"
                variant="outlined"
                fullWidth
                value={this.toDateTimeInput(p.dateTo, true)}
                onChange={(e) => this.changeSchedule('dateTo', e.target.value)}

                InputLabelProps={{ shrink: true }}
                error={errs.to || errs.range}
                helperText={errs.to ? 'Required' : errs.range ? 'From must be ≤ To' : 'Europe/Bucharest'}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', xl: 'span 2' }, minWidth: 0 }}>
              <TextField
                id="value"
                type="number"
                size="small"
                margin="dense"
                variant="outlined"
                label="Value"
                fullWidth
                value={p.value != null ? p.value : 0}
                onChange={this.changeValue}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', xl: 'span 2' }, minWidth: 0 }}>
              <TextField
                id="vCode"
                size="small"
                margin="dense"
                variant="outlined"
                label="Voucher Code"
                fullWidth
                value={p.vCode || ''}
                onChange={this.changeValue}
                required={!p.product && !p.combo}
                // helperText={!p.product && !p.combo ? 'Required if no product/combo' : ''}
              />
            </Box>

            {/* Eligible items */}
            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' }, minWidth: 0 }}>
              <Autocomplete
                options={this.state.productOpts}
                loading={this.state.productSearching}
                onInputChange={this.onProductInput}
                filterOptions={(x) => x}
                openOnFocus
                size="small"
                value={this.state.productObj}
                isOptionEqualToValue={(a, b) => a?.iref === b?.iref}
                onChange={(_, val) =>
                  this.setState((s) => ({
                    promotion: { ...s.promotion, product: val ? val.iref : null },
                    productObj: val || null,
                    somethingHasChanged: true,
                  }))
                }
                getOptionLabel={(opt) => opt?.name || ''}
                onOpen={async () => {
                  if (!this._prefetchedProd) {
                    this._prefetchedProd = true;
                    this.setState({ productSearching: true });
                    try {
                      const opts = await this.fetchList(API_URL_PRODUCTS, '');
                      this.setState({ productOpts: opts, productOptsAll: opts });
                    } finally {
                      this.setState({ productSearching: false });
                    }
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" margin="dense" variant="outlined" label="Product" fullWidth />
                )}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' }, minWidth: 0 }}>
              <Autocomplete
                options={this.state.comboOpts}
                loading={this.state.comboSearching}
                onInputChange={this.onComboInput}
                filterOptions={(x) => x}
                openOnFocus
                size="small"
                value={this.state.comboObj}
                isOptionEqualToValue={(a, b) => a?.iref === b?.iref}
                onChange={(_, val) =>
                  this.setState((s) => ({
                    promotion: { ...s.promotion, combo: val ? val.iref : null },
                    comboObj: val || null,
                    somethingHasChanged: true,
                  }))
                }
                getOptionLabel={(opt) => opt?.name || ''}
                onOpen={async () => {
                  if (!this._prefetchedCombo) {
                    this._prefetchedCombo = true;
                    this.setState({ comboSearching: true });
                    try {
                      const opts = await this.fetchList(API_URL_COMBOS, '');
                      this.setState({ comboOpts: opts, comboOptsAll: opts });
                    } finally {
                      this.setState({ comboSearching: false });
                    }
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" margin="dense" variant="outlined" label="Combo" fullWidth />
                )}
              />
            </Box>

            {/* Row 4: Description (12) */}
            <Box sx={{ gridColumn: '1 / -1' }}>
              <TextField
                id="description"
                label="Description"
                size="small"
                margin="dense"
                variant="outlined"
                multiline
                minRows={3}
                maxRows={6}
                fullWidth
                value={p.description || ''}
                onChange={this.changeValue}
                inputProps={{ maxLength: 2048 }}
              />
            </Box>
          </Box>
        </Box>
      );
    })();

    const detailsTab = (
      <Box sx={{ display:'block' }}>
        {this.state.edit ? detailsEdit : detailsReadOnly}
      </Box>
    );

    // ----- TRIGGERS (moved: client, family, professional, county, onBirthday) -----
    const triggersTab = (
      <Box
        sx={{
          p: 1,
          display: 'grid',
          gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
          gap: 1.25,
          alignItems: 'start',
          '& .MuiFormControl-root': {
            m: 0,
            width: '100%',
          },
          '& .MuiAutocomplete-root': {
            width: '100%',
          },
        }}
      >
        {this.state.edit ? (
          <>
            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', md: 'span 3' }, minWidth: 0 }}>
              <DropDown
                name="Gender"
                size="small"
                value={String(p.gender ?? 9)}
                doptions={this.state.genderOptions}
                hasIcons={false}
                minWidth={0}
                maxWidth={999}
                onDark={false}
                onChangeFunction={(v) => this.changeGender(v)}
                style={{ width: '100%' }}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', md: 'span 3' }, minWidth: 0 }}>
              <DropDown
                name="Proximity"
                size="small"
                value={String(p.proximity ?? 0)}
                doptions={this.state.proximityOptions}
                hasIcons={false}
                minWidth={0}
                maxWidth={999}
                onDark={false}
                onChangeFunction={(v) => this.changeProximity(v)}
                style={{ width: '100%' }}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3', md: 'span 2' }, minWidth: 0 }}>
              <TextField
                id="ageFrom"
                type="number"
                label="Age from"
                variant="outlined"
                size="small"
                fullWidth
                value={(p.ageFrom != null ? p.ageFrom : 0)}
                onChange={this.changeValue}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3', md: 'span 2' }, minWidth: 0 }}>
              <TextField
                id="ageTo"
                type="number"
                label="Age to"
                variant="outlined"
                size="small"
                fullWidth
                value={(p.ageTo != null ? p.ageTo : 0)}
                onChange={this.changeValue}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', md: 'span 2' }, minWidth: 0 }}>
              <FormControlLabel
                sx={{
                  m: 0,
                  minHeight: 40,
                  display: 'flex',
                  alignItems: 'center',
                }}
                control={
                  <Switch
                    id="onBirthday"
                    size="small"
                    checked={!!p.onBirthday}
                    onChange={(e) =>
                      this.changeValue({
                        target: {
                          id: 'onBirthday',
                          type: 'checkbox',
                          checked: e.target.checked,
                        },
                      })
                    }
                  />
                }
                label="Birthday"
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', md: 'span 4' }, minWidth: 0 }}>
              <TextField
                id="firstNameLike"
                label="First name like"
                variant="outlined"
                size="small"
                fullWidth
                value={p.firstNameLike || ''}
                onChange={this.changeValue}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', md: 'span 4' }, minWidth: 0 }}>
              <TextField
                id="orderAnciencyMonths"
                type="number"
                label="Order anciency months"
                variant="outlined"
                size="small"
                fullWidth
                value={(p.orderAnciencyMonths != null ? p.orderAnciencyMonths : 0)}
                onChange={this.changeValue}
              />
            </Box>

            <Box
              sx={{
                gridColumn: '1 / -1',
                minWidth: 0,
                p: 1,
                border: '1px solid #e0e0e0',
                borderRadius: 1,
              }}
            >
              <Typography variant="subtitle2" sx={{ mb: 0.75 }}>
                Client targeting
              </Typography>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', md: '280px 1fr' },
                  gap: 1,
                  alignItems: 'start',
                }}
              >
                <ToggleButtonGroup
                  exclusive
                  fullWidth
                  size="small"
                  value={this.state.targetMode}
                  onChange={this.setTargetMode}
                >
                  <ToggleButton value="all">All counties</ToggleButton>
                  <ToggleButton value="selected">Selected</ToggleButton>
                </ToggleButtonGroup>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  disabled={this.state.targetMode === 'all'}
                  options={this.state.counties}
                  getOptionLabel={(option) => option?.name || ''}
                  isOptionEqualToValue={(option, value) => (
                    option?.iref === value?.iref
                  )}
                  value={this.state.countyObjs}
                  limitTags={2}
                  ListboxProps={{
                    style: { height: 144, maxHeight: 144 },
                  }}
                  sx={{
                    '& .MuiAutocomplete-inputRoot': {
                      maxHeight: 112,
                      overflowY: 'auto',
                      alignItems: 'flex-start',
                    },
                  }}
                  size="small"
                  onChange={(_, value) => this.setState((state) => ({
                    countyObjs: value || [],
                    promotion: {
                      ...state.promotion,
                      county: value?.[0]?.iref || null,
                      counties: (value || []).map(
                        (county) => county.iref
                      ),
                    },
                    somethingHasChanged: true,
                  }))}
                  onOpen={() => {
                    if (!this.state.counties?.length) {
                      this.updateGeoData(
                        'country061',
                        this.countyIds(this.state.promotion),
                      );
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Client counties"
                      error={!countyTargetValid}
                      helperText={
                        this.state.targetMode === 'all'
                          ? 'One global promotion will cover every county'
                          : 'Choose one or more counties'
                      }
                      fullWidth
                    />
                  )}
                />
              </Box>
              <Box
                sx={{
                  mt: 1,
                  p: 1,
                  borderRadius: 1,
                  bgcolor: countyTargetValid
                    ? 'rgba(2, 136, 209, 0.06)'
                    : 'rgba(211, 47, 47, 0.06)',
                  border: '1px solid',
                  borderColor: countyTargetValid
                    ? 'info.light'
                    : 'error.light',
                }}
              >
                <Typography
                  variant="caption"
                  color={
                    countyTargetValid
                      ? 'text.secondary'
                      : 'error.main'
                  }
                >
                  {this.targetSummary()}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', md: 'span 6' }, minWidth: 0 }}>
              <Autocomplete
                options={this.state.familyOpts}
                loading={this.state.familySearching}
                onInputChange={this.onFamilyInput}
                filterOptions={(x) => x}
                openOnFocus
                size="small"
                value={this.state.familyObj}
                isOptionEqualToValue={(a, b) => String(a?.iref) === String(b?.iref)}
                getOptionLabel={(opt) => this.labelForFamily(opt)}
                noOptionsText="Type at least 2 characters to search families"
                onChange={(_, val) =>
                  this.setState((s) => ({
                    promotion: { ...s.promotion, family: val ? val.iref : null },
                    familyObj: val || null,
                    familyOpts: val ? [val] : [],
                    somethingHasChanged: true,
                  }))
                }
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;

                  return (
                    <Box
                      component="li"
                      {...optionProps}
                      key={`family-${option.iref}`}
                      sx={{
                        display: 'flex',
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        justifyContent: 'space-between',
                        gap: 1.5,
                        width: '100%',
                        py: 1,
                        flexDirection: { xs: 'column', sm: 'row' },
                        textAlign: 'left',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: '0.95rem',
                          fontWeight: 600,
                          lineHeight: 1.3,
                          minWidth: 0,
                        }}
                      >
                        {option.name || '—'}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          fontSize: '0.875rem',
                          lineHeight: 1.3,
                          minWidth: 0,
                          textAlign: { xs: 'left', sm: 'right' },
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: { xs: 'normal', sm: 'nowrap' },
                        }}
                      >
                        {option.owner_email || 'No owner email'}
                      </Typography>
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    label="Family group"
                    fullWidth
                    helperText="Search by family name or ID"
                  />
                )}
              />
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', md: 'span 6' }, minWidth: 0 }}>
              <Autocomplete
                options={this.state.professionalOpts}
                loading={this.state.professionalSearching}
                onInputChange={this.onProfessionalInput}
                filterOptions={(x) => x}
                openOnFocus
                size="small"
                value={this.state.professionalObj}
                isOptionEqualToValue={(a, b) => String(a?.iref) === String(b?.iref)}
                getOptionLabel={(opt) => this.labelForProfessional(opt)}
                noOptionsText="Type at least 2 characters to search professional groups"
                onChange={(_, val) =>
                  this.setState((s) => ({
                    promotion: { ...s.promotion, professional: val ? val.iref : null },
                    professionalObj: val || null,
                    professionalOpts: val ? [val] : [],
                    somethingHasChanged: true,
                  }))
                }
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const mainLabel = option.company
                    ? `${option.name || '—'} / ${option.company}`
                    : (option.name || '—');

                  return (
                    <Box
                      component="li"
                      {...optionProps}
                      key={`professional-${option.iref}`}
                      sx={{
                        display: 'flex',
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        justifyContent: 'space-between',
                        gap: 1.5,
                        width: '100%',
                        py: 1,
                        flexDirection: { xs: 'column', sm: 'row' },
                        textAlign: 'left',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: '0.95rem',
                          fontWeight: 600,
                          lineHeight: 1.3,
                          minWidth: 0,
                        }}
                      >
                        {mainLabel}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          fontSize: '0.875rem',
                          lineHeight: 1.3,
                          minWidth: 0,
                          textAlign: { xs: 'left', sm: 'right' },
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: { xs: 'normal', sm: 'nowrap' },
                        }}
                      >
                        {option.owner_email || 'No owner email'}
                      </Typography>
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    label="Professional group"
                    fullWidth
                    helperText="Search by professional group name or ID"
                  />
                )}
              />
            </Box>
          </>
        ) : (
          <>
            <Box sx={{ gridColumn: { xs: 'span 12', md: 'span 4' } }}>
              <Typography variant="subtitle2">Audience</Typography>
              <Typography variant="body2" color="text.secondary">
                Gender: {genderLabel} • Proximity: {proxLabel} • Age: {(p.ageFrom ?? '—')} – {(p.ageTo ?? '—')}
              </Typography>
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', md: 'span 4' } }}>
              <Typography variant="subtitle2">Conditions</Typography>
              <Typography variant="body2" color="text.secondary">
                On birthday: {p.onBirthday ? 'Yes' : 'No'}<br />
                First name like: {p.firstNameLike || '—'}<br />
                Order anciency: {p.orderAnciencyMonths ?? '—'} months
              </Typography>
            </Box>

            <Box sx={{ gridColumn: { xs: 'span 12', md: 'span 4' } }}>
              <Typography variant="subtitle2">Groups</Typography>
              <Typography variant="body2" color="text.secondary">
                Family group: {this.labelForFamily(this.state.familyObj) || '—'}<br />
                Professional group: {this.labelForProfessional(this.state.professionalObj) || '—'}<br />
                Client counties: {this.countyNames(p)}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    );

    const translationsTab = (
      <Box sx={{ p: 1, display:'grid', gridTemplateColumns:'1fr', gap: 1 }}>
        {this.state.allowEdit && this.state.promotion?.iref && (
          <Box sx={{ display:'flex', gap: 1, justifyContent:'flex-end' }}>
            <Button size="small" variant="outlined" onClick={this.addBlankTranslation} disabled={this.hasOpenDraft()}>Add translation</Button>
          </Box>
        )}

        {this.state.translations.length === 0 ? (
          <Typography variant="body2" color="text.secondary">No translations yet.</Typography>
        ) : (
          this.state.translations.map((t) => {
            const isTemp = (t.iref < 0);
            return (
              <Box
                key={t.iref}
                sx={{
                  p: 0.5,
                  borderRadius: 1,
                  border: '1px solid #e0e0e0',
                  display: 'grid',
                  gridTemplateColumns: '200px 1fr',
                  gap: 0.5
                }}
              >
                {/* Language */}
                <Box sx={{ display:'grid', gap: 0.25 }}>
                  {this.canEditTrRow(t) ? (
                    <Autocomplete
                      options={this.state.languages}
                      size="small"
                      disablePortal
                      getOptionLabel={(opt) => opt?.languageName || ''}
                      isOptionEqualToValue={(opt, val) => opt?.iref === val?.iref}
                      value={(this.state.languagesReady && t.language) ? (this.state.langById[t.language] || null) : null}
                      onChange={(_, val) => this.onTrFieldChange(t.iref, 'language', val ? val.iref : null)}
                      renderInput={(params) => <TextField {...params} variant="outlined" label="Language" size="small" />}
                      ListboxProps={{ sx: { maxHeight: 200, p: 0 } }}
                      sx={{ minWidth: 200, mt: 1}}
                      disabled={!this.state.languagesReady}
                    />
                  ) : (
                    <>
                      <Typography variant="caption" color="text.secondary">Language</Typography>
                      <Typography variant="body2">
                        {!this.state.languagesReady ? '…' : (t.language ? (this.state.langById[t.language]?.languageName || '—') : '—')}
                      </Typography>
                    </>
                  )}
                </Box>

                {/* Name + Description */}
                <Box sx={{ display:'grid', gap: 0.25 }}>
                  {this.canEditTrRow(t) ? (
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 2fr auto',
                        columnGap: 0.5,
                        rowGap: 0.25,
                        alignItems: 'center'
                      }}
                    >
                      {/* Name */}
                      <TextField
                        size="small"
                        margin="dense"
                        label="Name"
                        variant="outlined"
                        value={t.name || ''}
                        inputProps={{ maxLength: 100 }}
                        onChange={(e)=>this.onTrFieldChange(t.iref, 'name', e.target.value)}
                      />
                      {/* Description */}
                      <TextField
                        size="small"
                        margin="dense"
                        label="Description"
                        variant="outlined"
                        value={t.description || ''}
                        inputProps={{ maxLength: 1024 }}
                        onChange={(e)=>this.onTrFieldChange(t.iref, 'description', e.target.value)}
                      />
                      {/* Actions */}
                      <Box sx={{ display:'flex', gap: 0.5, justifyContent:'flex-end', mt: 1 }}>
                        <Button
                          size="small"
                          variant="contained"
                          disabled={this.state.isSavingTr}
                          onClick={()=>this.saveTranslation(t)}
                        >
                          {this.state.isSavingTr ? 'Saving…' : (isTemp ? 'Add' : 'Save')}
                        </Button>
                        <Button
                          size="small"
                          onClick={()=>{
                            if (t.iref < 0) {
                              this.setState(s => ({
                                translations: (s.translations || []).filter(x => x.iref !== t.iref),
                                trEdit: { ...s.trEdit, [t.iref]: false }
                              }));
                            } else {
                              this.toggleTrEdit(t.iref, false);
                            }
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Box>
                  ) : (
                    <Box sx={{ display:'flex', alignItems:'baseline', justifyContent:'space-between' }}>
                      {/* Name + description inline */}
                      <Box sx={{ display:'flex', gap: 1, flexWrap:'wrap' }}>
                        <Typography variant="subtitle2">{t.name || '—'}</Typography>
                        <Typography variant="body2" color="text.secondary">{t.description || '—'}</Typography>
                      </Box>
                      {this.state.allowEdit && (
                        <Button size="small" onClick={()=>this.toggleTrEdit(t.iref, true)}>Edit</Button>
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            );
          })
        )}
      </Box>
    );

    const saveButtonVisible = (
      this.state.edit
      && this.state.somethingHasChanged
      && countyTargetValid
    );

    return (
      <Card sx={{ borderRadius: '16px', m: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <CardHeader
            avatar={<Avatar alt={activeAlt} src={activeAvatar} title={activeAlt} />}
            action={
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                {this.state.edit ? (
                  <>
                    {this.state.somethingHasChanged ? (
                      <Typography variant="caption" color="warning.main" sx={{ display: { xs: 'none', sm: 'inline' }, whiteSpace: 'nowrap' }}>
                        Unsaved changes
                      </Typography>
                    ) : null}
                    <Button
                      size="small"
                      variant="text"
                      disabled={this.state.isSaving}
                      onClick={this.handleCancelClick}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<SaveIcon />}
                      disabled={
                        this.state.isSaving ||
                        !saveButtonVisible ||
                        bothSelected ||
                        !this.hasValidDates() ||
                        this.parseClaimLimit(p.maxClaims) === undefined ||
                        (Number(p.type) === 0 && !p.product && !p.combo)
                      }
                      onClick={this.handleSaveClick}
                    >
                      {this.state.isSaving ? 'Saving…' : 'Save'}
                    </Button>
                  </>
                ) : (
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<EditIcon />}
                    onClick={this.handleEditClick}
                    disabled={!this.state.allowEdit}
                  >
                    Edit
                  </Button>
                )}
                <ExpandMore
                  expand={this.state.expanded}
                  onClick={this.handleExpandClick}
                  aria-expanded={this.state.expanded}
                  aria-label={this.state.expanded ? 'Collapse promotion' : 'Expand promotion'}
                >
                  <ExpandMoreIcon />
                </ExpandMore>
              </Box>
            }
            title={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {title}
                </Typography>
                <Chip
                  size="small"
                  label={p.isActive ? 'Active' : 'Inactive'}
                  color={p.isActive ? 'success' : 'default'}
                  variant="outlined"
                />
                <Chip
                  size="small"
                  label={
                    this.countyIds(p).length
                      ? `${this.countyIds(p).length} ${this.countyIds(p).length === 1 ? 'county' : 'counties'}`
                      : 'All counties'
                  }
                  color="primary"
                  variant="outlined"
                />
                {!this.state.edit && p.maxClaims != null ? (
                  <Chip
                    size="small"
                    label={`Max claims: ${p.maxClaims}`}
                    variant="outlined"
                  />
                ) : null}
                {p.has_price_list_warning ? (
                  <Chip
                    size="small"
                    icon={<WarningAmberIcon />}
                    color="warning"
                    variant="outlined"
                    label={priceWarningLabel}
                  />
                ) : null}
              </Box>
            }
            subheader={subheader}
            disableTypography
            sx={{ '& .MuiCardHeader-action': { alignSelf: 'center', m: 0 } }}
          />

          {!this.state.edit ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, pb: 1 }}>
              <CardMedia
                component="img"
                sx={{ width: 88, height: 88, objectFit: 'cover', flexShrink: 0, borderRadius: 1 }}
                src={this.safeImageSrc(promoImage)}
                alt={title}
                onError={(e) => { e.currentTarget.src = noImage; }}
              />
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="body2" color="text.secondary">
                  {p.dateFrom ? `From: ${this.scheduleLabel(p.dateFrom)}` : 'From: —'}
                  {p.dateTo ? ` → ${this.scheduleLabel(p.dateTo, true)}` : ''}
                </Typography>
                {(p.pin_position > 0 || p.vCode) ? (
                  <Typography variant="caption" color="text.secondary">
                    {p.pin_position > 0 ? `Top: ${this.state.pinOptions[p.pin_position]}` : ''}
                    {p.pin_position > 0 && p.vCode ? ' • ' : ''}
                    {p.vCode ? `Code: ${p.vCode}` : ''}
                  </Typography>
                ) : null}
              </Box>
            </Box>
          ) : null}

          <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
            <CardContent sx={{ pt: '8px' }}>
              <Box sx={{ width: '100%' }}>
                <Tabs value={this.state.tabValue} onChange={this.handleTabChange} centered indicatorColor="secondary">
                  <Tab label="Details" value="details" icon={<LoyaltyIcon />} iconPosition="start" />
                  <Tab label="Triggers" value="triggers" icon={<EventIcon />} iconPosition="start" />
                  <Tab label="Translations" value="translations" icon={<TranslateIcon />} iconPosition="start" />
                </Tabs>
              </Box>

              {this.state.tabValue === 'details'      ? detailsTab      : null}
              {this.state.tabValue === 'triggers'     ? triggersTab     : null}
              {this.state.tabValue === 'translations' ? translationsTab : null}
            </CardContent>
          </Collapse>
        </Box>
      </Card>
    );
  }
}
